export class KeyCode {
  static BACKSPACE = 8;
  static TAB = 9;
  static ENTER = 13;
  static SHIFT = 16;
  static ESCAPE = 27;
  static SPACE = 32;
  static LEFT = 37;
  static UP = 38;
  static RIGHT = 39;
  static DOWN = 40;
  static DELETE = 46;

  static A = 65;
  static C = 67;
  static V = 86;
  static D = 68;
  static Z = 90;
  static Y = 89;

  static F2 = 113;

  static PAGE_UP = 33;
  static PAGE_DOWN = 34;
  static PAGE_HOME = 36;
  static PAGE_END = 35;
}
